import { render, staticRenderFns } from "./EmotionRegulation.vue?vue&type=template&id=42db4499&scoped=true&"
import script from "./EmotionRegulation.vue?vue&type=script&lang=js&"
export * from "./EmotionRegulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42db4499",
  null
  
)

export default component.exports